export default "__VITE_ASSET__Ch4nxG7C__"